import Vue from 'vue'
import Vuex from 'vuex'

import i18n from '@/plugins/i18n'

import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

import createI18nPlugin from './plugins/i18n'

Vue.use(Vuex)

const i18nPlugin = createI18nPlugin(i18n)

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [i18nPlugin]
})
